module.exports = __webpack_public_path__ + "src/assets/img/car_device.ef15c8c0.png";